// P3-024: React container for Phaser BattleScene canvas
// Correct sized div, pointer events pass through to Phaser, responsive scaling

import { useEffect, useRef } from 'react';
import { getGame, registerScene } from '@/shared/game/main';
import { BattleScene, BATTLE_SCENE_KEY } from '../scenes/BattleScene';

export function BoardView() {
  const containerRef = useRef<HTMLDivElement>(null);
  const sceneStarted = useRef(false);

  useEffect(() => {
    const game = getGame();
    if (!game || sceneStarted.current) return;

    // Register the BattleScene if not already registered
    registerScene(BATTLE_SCENE_KEY, BattleScene);

    // Start the scene
    const existingScene = game.scene.getScene(BATTLE_SCENE_KEY);
    if (existingScene) {
      if (!game.scene.isActive(BATTLE_SCENE_KEY)) {
        game.scene.start(BATTLE_SCENE_KEY);
      }
    } else {
      // Scene was just registered, start it
      game.scene.start(BATTLE_SCENE_KEY);
    }

    sceneStarted.current = true;

    return () => {
      const currentGame = getGame();
      if (currentGame) {
        const scene = currentGame.scene.getScene(BATTLE_SCENE_KEY);
        if (scene && currentGame.scene.isActive(BATTLE_SCENE_KEY)) {
          currentGame.scene.stop(BATTLE_SCENE_KEY);
        }
      }
      sceneStarted.current = false;
    };
  }, []);

  return (
    <div ref={containerRef} className="board-view">
      {/* The Phaser canvas is rendered by PhaserGame at the root level.
          This div acts as a layout placeholder so the React HUD
          positions correctly around the board area. */}
    </div>
  );
}
